import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, mergeMap, catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import {ApiService} from '../../../core/http/api.service';
import {GetPropertyDetailsResponseModel} from '../../../shared/models/properties/properties.models';
import {LoadPropertyDetailsActionParams} from '../../models/property.model';
import { PropertyDetailsActions } from '../../actions/property/property-details.actions';

@Injectable()
export class PropertyDetailsEffects {

   loadPropertyDetails$ = createEffect(() => this.actions$
    .pipe(
      ofType(PropertyDetailsActions.loadPropertyDetails),
      mergeMap(
        (data: LoadPropertyDetailsActionParams) => this.api.Properties.getPropertyDetails(data.propertyId, data.params, data.guest)
          .pipe(
            map((response: GetPropertyDetailsResponseModel) => PropertyDetailsActions.loadPropertyDetailsSuccess(response)),
            catchError(error => of(PropertyDetailsActions.loadPropertyDetailsFailure(error)))
          )
      )
    ));

  constructor(
    private actions$: Actions,
    private api: ApiService
  ) {}
}
